var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftFlat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.429 20.428H.002V.001h20.427v20.427z",
    fill: "#F25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.98 20.427H22.553V0H42.98v20.427z",
    fill: "#7FBA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.427 42.98H0V22.553h20.427V42.98z",
    fill: "#00A4EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.98 42.98H22.553V22.553H42.98V42.98z",
    fill: "#FFB900"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCA0MyA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjQyOSAyMC40MjgzSDAuMDAxOTUzMTJWMC4wMDEyNTY5NEgyMC40MjlWMjAuNDI4M1oiIGZpbGw9IiNGMjUwMjIiLz4KPHBhdGggZD0iTTQyLjk3OTggMjAuNDI3MUgyMi41NTI3VjMuNjIzOTZlLTA1SDQyLjk3OThWMjAuNDI3MVoiIGZpbGw9IiM3RkJBMDAiLz4KPHBhdGggZD0iTTIwLjQyNyA0Mi45Nzk5SDBWMjIuNTUyOUgyMC40MjdWNDIuOTc5OVoiIGZpbGw9IiMwMEE0RUYiLz4KPHBhdGggZD0iTTQyLjk3OTggNDIuOTc5OEgyMi41NTI3VjIyLjU1MjhINDIuOTc5OFY0Mi45Nzk4WiIgZmlsbD0iI0ZGQjkwMCIvPgo8L3N2Zz4K";
export { SvgMicrosoftFlat as ReactComponent };